// extracted by mini-css-extract-plugin
export default {"repositoryNameTruncate":"IssuePullRequestDescription-module__repositoryNameTruncate--MZZas","RelativeTime":"IssuePullRequestDescription-module__RelativeTime--C5F2W"};